import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import PageLayout from "components/layout/PageLayout"
import { useEditCompanyInfoMutation, useGetMyCompanyInfoQuery } from "./api/companyApiSlice"
import CompanyNav from "./components/CompanyNav"
import SuccessMessage from "components/commons/SuccessMessage"
import SMTPSettings from "./views/SMTPSettings"

const EditCompany = () => {

    const [t, i18n] = useTranslation("global")
    const apiUrl = process.env.REACT_APP_API_URL

    const [companyName, setCompanyName] = useState("")
    const [companyVAT, setCompanyVAT] = useState("")
    const [companyImage, setCompanyImage] = useState(null);
    const [smtpmSettings, setSMTPSettings] = useState({})

    const {
        data: companyInfo,
        isFetching: companyInfoIsFetching,
        isSuccess: companyInfoIsSuccess,
        isLoading: companyInfoIsLoading,
        isError: companyInfoIsError,
        error: companyInfoError,
        refetch,
    } = useGetMyCompanyInfoQuery()

    const [
        sendRequest, {
            data: editResult,
            isLoading: editIsLoading,
            isSuccess: editSuccess,
            reset: editReset
        }
    ] = useEditCompanyInfoMutation()


    useEffect(() => {
        if (companyInfoIsSuccess) {
            setCompanyName(companyInfo.company.name)
            setCompanyVAT(companyInfo.company.vat)
        }

    }, [companyInfoIsSuccess])

    const handleCompanyNameChange = (e) => setCompanyName(e.target.value)
    const handleCompanyVATChange = (e) => setCompanyVAT(e.target.value)
    const handleImageChange = (event) => {
        setCompanyImage(event.target.files[0]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault()

        const payload = {
            name: companyName,
            vat: companyVAT
        }
        console.log("Payload: " + JSON.stringify(payload))


        const formData = new FormData();
        formData.append('companyEdit', new Blob([JSON.stringify(payload)], { type: 'application/json' }));
        formData.append('image', companyImage);


        sendRequest(formData)
    }

    let content

    if (companyInfoIsSuccess) {

        content =
            <>
                <CompanyNav />
                {
                    editSuccess &&
                    <SuccessMessage />
                }
                <div className="card bg-black bg-opacity-10 text-white mb-4">
                    <div className="card-header">
                        <i className="fa-solid fa-circle-info"></i>  {t("property.infos")}
                    </div>
                    <div className="card-body">

                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <h5 className="text-muted">Generali</h5>
                                <div className="col-md-6 mb-3">
                                    <label htmlFor="employeeFirstName">{t("property.name")}</label>
                                    <input type="text" className="form-control" id="employeeFirstName" onChange={handleCompanyNameChange} value={companyName} placeholder="" required />
                                    <div className="invalid-feedback">
                                        Valid first name is required.
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <label htmlFor="lastName">{t("property.vat")}</label>
                                    <input type="text" role="presentation" className="form-control" id="employeeLastName" onChange={handleCompanyVATChange} value={companyVAT} placeholder="" />
                                    <div className="invalid-feedback">
                                        Valid last name is required.
                                    </div>
                                </div>
                            </div>
                            <hr className="mb-3" />
                            <div className="row">
                                {
                                    companyInfo.company.img &&
                                    <div className="col-md-3 mb-3">
                                        <img width="200" src={`${apiUrl}/file?file=${companyInfo.company.img}`} />
                                    </div>
                                }

                                <div className="col-md-6 mb-3">
                                    <label htmlFor="lastName"><i className="fa-solid fa-image"></i> Change Logo</label><br />
                                    <input type="file" onChange={handleImageChange} accept="image/*" />
                                    <div className="invalid-feedback">
                                        Valid last name is required.
                                    </div>
                                </div>
                            </div>
                            <hr className="mb-3" />
{/* 
                            <SMTPSettings onChange={setSMTPSettings} value={smtpmSettings} />
                            <hr className="mb-3" /> */}
                            <button className="btn mb-3 btn-primary btn-lg btn-block"><i className="fa-solid fa-floppy-disk"></i> {t("action.save")}</button>
                        </form>
                    </div>
                </div>
            </>
    }

    return <PageLayout
        pageTitle={t("menu.edit_company")}
        onPageRefresh={refetch}
        isLoadingContent={editIsLoading || companyInfoIsFetching}
        isLoadingPage={companyInfoIsLoading}
        bodyContent={content}
    />
}

export default EditCompany